import { LineItemReturnState } from "@redotech/redo-return-operations-common/draft-return/line-item-verdicts";
import * as z from "zod";

const verdictBase = { lineItemId: z.string(), actionSuppressed: z.boolean() };

const blockedCounts = {
  blockedCount: z.number(),
  totalCount: z.number(),
  message: z.string().nullable(),
};

/** Each state carries only the fields it can answer for. */
const lineItemReturnVerdictSchema = z.discriminatedUnion("state", [
  z.object({ ...verdictBase, state: z.literal(LineItemReturnState.ELIGIBLE) }),
  z.object({
    ...verdictBase,
    state: z.literal(LineItemReturnState.PRESET_SET),
    presetStepName: z.string().nullable(),
  }),
  z.object({
    ...verdictBase,
    ...blockedCounts,
    state: z.literal(LineItemReturnState.BLOCKED),
  }),
  z.object({
    ...verdictBase,
    ...blockedCounts,
    state: z.literal(LineItemReturnState.PARTIALLY_BLOCKED),
  }),
  z.object({
    ...verdictBase,
    state: z.literal(LineItemReturnState.NOT_RETURNABLE),
    message: z.string(),
  }),
]);

const getLineItemReturnVerdictsInputSchema_ = z.object({ orderId: z.string() });

export const getLineItemReturnVerdictsInputSchema: z.ZodType<GetLineItemReturnVerdictsInput> =
  getLineItemReturnVerdictsInputSchema_;
export interface GetLineItemReturnVerdictsInput extends z.infer<
  typeof getLineItemReturnVerdictsInputSchema_
> {}

const getLineItemReturnVerdictsOutputSchema_ = z.object({
  /** Empty when the team has not enabled pre-rejection. */
  verdicts: z.array(lineItemReturnVerdictSchema),
});

export const getLineItemReturnVerdictsOutputSchema: z.ZodType<GetLineItemReturnVerdictsOutput> =
  getLineItemReturnVerdictsOutputSchema_;
export interface GetLineItemReturnVerdictsOutput extends z.infer<
  typeof getLineItemReturnVerdictsOutputSchema_
> {}

export const getLineItemReturnVerdicts = {
  name: "getLineItemReturnVerdicts" as const,
  input: getLineItemReturnVerdictsInputSchema,
  output: getLineItemReturnVerdictsOutputSchema,
};
